import React, { useEffect, useState } from "react";
import { VerticalDivider } from "../../common/SVGs";

const InputWithLabel = ({ type = "checkbox", label, checked, onChange ,name="", disabled=false }) => (
  <label style={{ display: "inline", margin: "0px" }}>
    <input
      type={type}
      style={type === "checkbox" ? { width: "13px", height: "13px" } : { width: "13px" }}
      checked={checked}
      onChange={onChange}
      name={name}
      disabled={disabled}
    />
    <span style={{ fontSize: "13.5px", fontWeight: "normal" }}>{label}</span>
  </label>
);

const TypesFilter = ({filterState, setFilterState}) => {

  const stateUpdator = (type,booleanFlag) =>{
    setFilterState(prev => {
      const updated = {...prev, filterByType: type};
      const typeFilters = {...updated.typeFilters}
      Object.keys(filterState.typeFilters).map((t)=>{
        typeFilters[t] = booleanFlag
      });
      updated.typeFilters = typeFilters;


      return updated
    })
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          padding: "8px 10px", // Added padding for spacing
          boxShadow: " 0px 0px 8px 0px rgba(0, 0, 0, 0.3)",
          borderRadius: "5px",
          marginBottom: "20px",
        }}
      >
        <span style={{ fontSize: "13px", marginTop: "2px" }}>
          <b>Filter by Type:</b>
        </span>
        <InputWithLabel
          type="radio"
          checked={filterState.filterByType === "all"}
          onChange={() => stateUpdator("all",true)}
          name="select-type"
          label={"All Types"}
        />
        &nbsp;
        <InputWithLabel
          type="radio"
          checked={filterState.filterByType === "No Types"}
          onChange={()=>stateUpdator("No Types",false)}
          name="select-type"
          label={"No Types"}
        />
        &nbsp;
         <InputWithLabel
          type="radio"
          checked={filterState.filterByType === "Select Types"}
          onChange={() => setFilterState(prev => ({ ...prev, filterByType: "Select Types" }))}
          name="select-type"
          label={"Select Types"}
        />
        <VerticalDivider />
        <div style={{ width: "70%" }}>
          {Object.keys(filterState.typeFilters).map((t) => (
            <InputWithLabel
              key={t}
              type="checkbox"
              checked={filterState.typeFilters[t]}
              label={t}
              onChange={e =>
                setFilterState(prev => ({
                  ...prev,
                  typeFilters: { ...prev.typeFilters, [t]: e.target.checked }
                }))
              }
              disabled={filterState.filterByType !== "Select Types"}
            />
          ))}
        </div>
      </div>
      <div style={{ padding: "10px" }}></div>
    </>
  );
};

export default TypesFilter;
